import CreditService from "@/services/credit";
import * as types from "./mutationTypes";
import { CICLE_DURATION, DEAL_TYPE } from "@/consts/credit";

export default {
  clearCredits({ commit }) {
    commit(types.CLEAR_CREDITS);
  },
  clearPlan({ commit }) {
    commit(types.CLEAR_PLAN);
  },
  async getCredits({ commit, dispatch, rootState }) {
    const { uuid } = rootState.organization.organization;

    try {
      const { data } = await CreditService.getAll(uuid);
      dispatch("setCredits", data.data);
      dispatch("setPlan", data.data);
    } catch (error) {
      commit(types.SET_ERROR, { status: true });
    }
  },
  async getPlan({ commit, dispatch, rootState }) {
    const { uuid } = rootState.organization.organization;

    try {
      const { data } = await CreditService.getAll(uuid);
      dispatch("setPlan", data.data);
    } catch (error) {
      commit(types.SET_ERROR, { status: true });
    }
  },
  setCredits({ dispatch }, credits) {
    dispatch("setExtraCredits", credits);
    dispatch("setInitialCredits", credits);
    dispatch("setStandardCredits", credits);
    dispatch("setLastTransactions", credits);
  },
  setInitialCredits({ commit }, credits) {
    const initialCredits = credits.deals
      .filter((credit) => credit.type === DEAL_TYPE.primary)
      .filter((credit) => credit.initial_non_expired_credits > 0)
      .map((credit) => ({
        uuid: credit.uuid,
        used: credit.initial_non_expired_credits - credit.last_transaction.non_expired_credits,
        total: credit.initial_non_expired_credits
      }));
    commit(types.SET_INITIAL_CREDIT, { initialCredits });
  },
  setStandardCredits({ commit }, credits) {
    const primaryDeal = credits.deals.find((credit) => credit.type === DEAL_TYPE.primary);
    const standardCredits = getStandardCredits(primaryDeal);
    commit(types.SET_STANDARD_CREDIT, { standardCredits });
  },
  setExtraCredits({ commit }, credits) {
    const extraCredits = credits.deals
      .filter((credit) => credit.type === DEAL_TYPE.secondary)
      .map((credit) => ({
        uuid: credit.uuid,
        used: credit.credits - credit.last_transaction.credits,
        total: credit.credits,
        endDate: credit.due_date
      }));
    commit(types.SET_EXTRA_CREDITS, { extraCredits });
  },
  setLastTransactions({ commit }, credits) {
    const lastTransactions = credits.last_transactions;
    commit(types.SET_LAST_TRANSACTIONS, { lastTransactions });
  },
  setPlan({ commit }, credits) {
    const primaryDeal = credits.deals.find((credit) => credit.type === DEAL_TYPE.primary);
    const plan = {
      credits: primaryDeal.credits,
      extra: primaryDeal.extra_credits,
      cicle: CICLE_DURATION[primaryDeal.cicle_duration],
      renewalDay: primaryDeal.renewal_day,
      dueDate: primaryDeal.due_date,
      creditSms: primaryDeal.credits_sms,
      extraSms: primaryDeal.extra_sms
    };
    commit(types.SET_PLAN, plan);
  }
};

const hasRenewal = (credit) => {
  return credit.start_current_cicle !== credit.start_date;
};

const getUsedCredits = (credit) => {
  return credit.credits - credit.last_transaction.credits;
};

const getUsedExtraCredits = (credit) => {
  return credit.extra_credits - credit.last_transaction.extra_credits;
};

const getStandardCredits = (primaryDeal) => {
  let used = getUsedCredits(primaryDeal);
  let excessUsed = getUsedExtraCredits(primaryDeal);
  let total = primaryDeal.credits;
  let excessTotal = primaryDeal.extra_credits;
  let startDate = primaryDeal.start_current_cicle;
  let endDate = primaryDeal.end_current_cicle;
  if (!hasRenewal(primaryDeal)) {
    used = primaryDeal.last_transaction.credits > 0 ? used : 0;
    total = primaryDeal.last_transaction.credits > 0 ? total : 0;
    excessUsed = primaryDeal.last_transaction.extra_credits > 0 ? excessUsed : 0;
    excessTotal = primaryDeal.last_transaction.extra_credits > 0 ? excessUsed : 0;
    startDate = primaryDeal.last_transaction.credits > 0 ? startDate : null;
    endDate = primaryDeal.last_transaction.credits > 0 ? endDate : null;
  }

  return [
    {
      uuid: primaryDeal.uuid,
      used,
      total,
      excessUsed,
      excessTotal,
      startDate,
      endDate
    }
  ];
};
